export default __webpack_public_path__ + "static/media/CNo.80-1.b9743770.jpg";